import InfoWrapper from 'components/shared/InfoWrapper'
import Icon from 'components/shared/Icon'
import Link from 'components/shared/Link'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import { useApp } from 'store/steps'

const AttractionsInfo = () => {
    const { goBackToStep } = useApp()

    const handleRedirectToTickets = () => goBackToStep('tickets')

    return (
        <InfoWrapper
            direction={['column', 'row']}
            gap={[16, 12]}
            align={['flex-end', 'center']}
            padding={24}
            pl={[16, 24]}
            pr={[16, 24]}
        >
            <Box direction="row" gap={12} align={['flex-start', 'center']}>
                <Icon variant="ticket-2" color="secondary_500" />
                <Text variant="body" mr={[0, 16]} color="grayscale_900">
                    <FormattedMessage
                        id="upsells.attractions_info"
                        defaultMessage="Z atrakcji (oprócz Suntago Busa) możesz skorzystać tylko z biletem do parku."
                    />
                </Text>
            </Box>
            <Link
                variant="secondary"
                onClick={handleRedirectToTickets}
                data-testid="upsells-goto-tickets-step"
            >
                <FormattedMessage
                    id="upsells.btn.buy_tickets"
                    defaultMessage="Kup bilety"
                />
            </Link>
        </InfoWrapper>
    )
}

export default AttractionsInfo
